import symbol from "./symbol.js";
import symbolDS4 from "./symbol[ds-4].js";
<ebay-icon ...input _name="chevron-left-small" _type="icon" _themes=[symbol, symbolDS4]/>
